"use client";

import { useTransition, useState } from "react";
import { Button } from "@/components/ui/Button";
import { Input } from "@/components/ui/Input";
import { signInWithPin } from "@/lib/login-actions";
import { useRouter } from "next/navigation";

export function PinLoginForm({ redirectTo }: { redirectTo: string }) {
  const [pending, start] = useTransition();
  const [error, setError] = useState<string | null>(null);
  const router = useRouter();

  function handleSubmit(formData: FormData) {
    start(async () => {
      const pin = formData.get("pin") as string;
      const res = await signInWithPin(pin, redirectTo);
      if (res?.error) {
        setError(res.error);
      } else {
        // Successful login is handled by the redirect inside signInWithPin or we can just refresh
      }
    });
  }

  return (
    <div>
      {error && (
        <p className="mb-3 rounded-lg border border-danger-line bg-danger-subtle px-3 py-2 text-xs text-danger-strong">
          {error}
        </p>
      )}
      <form action={handleSubmit} className="flex gap-2">
        <Input type="password" name="pin" placeholder="PIN" className="w-full" disabled={pending} />
        <Button type="submit" variant="secondary" disabled={pending} className="shrink-0">
          {pending ? "..." : "Enter"}
        </Button>
      </form>
    </div>
  );
}
